import React, { useEffect, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "../../Style/Dashboard.css";

import DashboardLayoutStatistics from "./DashboardLayoutStatistics";
import DashboardLayoutPerformance from "./DashboardLayoutPerformance";

import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../../Config/Url";

const Dashboard = () => {
  const { t: translator } = useTranslation();
  const history = useHistory();
  const {
    updateLocTab,
    updateLocTenant,
    updateLocName,
    updateLocUser,
    updateLocStore,
    updateLocPos,
  } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const [tab, setTab] = useState("statistics");
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    axios
      .get(`${apiUrl}/Widget`)
      .then((res) => setIsAuth(true))
      .catch((err) => history.push("/error-page/401"));

    if (![master, admin, support].includes(Number(roleId)))
      history.push("/error-page/401");

    updateLocTab(0);
    updateLocTenant(0);
    updateLocUser(0);
    updateLocName("");
    updateLocStore(0);
    updateLocPos(0);
  }, []);

  const handleSelect = (tabId) => {
    setTab(tabId);
  };

  return (
    <>
      {isAuth && (
        <Tabs
          defaultActiveKey="statistics"
          id="dashboard-contents"
          className="dashboard-tab mt-2"
          onSelect={(tabId) => handleSelect(tabId)}
        >
          <Tab
            eventKey="statistics"
            title={translator("Dashboard-Dashboard-StatisticsTab")}
            className="dashboard-tab"
            tabClassName="mob-tabs"
          >
            {tab === "statistics" && <DashboardLayoutStatistics />}
          </Tab>

          {/* <Tab
            eventKey="performance"
            title={translator("Dashboard-Dashboard-PerformanceTab")}
            className="dashboard-tab dashboard-tab-text"
            tabClassName="mob-tabs"
          >
            {tab === "performance" && <DashboardLayoutPerformance />}
          </Tab> */}
        </Tabs>
      )}
    </>
  );
};

export default Dashboard;
